import { GlButton } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'AiCatalogFormButtons',
    components: {
        GlButton
    },
    props: {
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        cancelRoute: {
            type: Object,
            required: true
        }
    }
};
